"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JurisdictionAdminPage = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const FiltersBar_1 = require("@juvare/common-data-table-ui/FiltersBar");
const PageHeader_1 = require("@juvare/common-web-ui/PageHeader");
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const hooks_1 = require("../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const JurisdictionAdminPage = () => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const { dataTableProps, filtersBarProps } = (0, DataTable_1.useDataTableUsingUrl)({
        useDataProvider: useJurisdictionList,
        defaultSortColumnKey: 'name',
        maxUrlSearchLength: 200,
    });
    const columns = react_1.default.useMemo(() => [
        {
            headerLabel: t('defaultClassifiers.jurisdiction'),
            sortKey: 'name',
            cellFunction: (row) => {
                let name;
                if (row.columns.parentName) {
                    name = row.columns.name + ' (' + row.columns.parentName + ')';
                }
                else {
                    name = row.columns.name;
                }
                let type = '';
                switch (row.columns.type) {
                    case 'state':
                        type = t('defaultClassifiers.state');
                        break;
                    case 'county':
                        type = t('defaultClassifiers.county');
                        break;
                    case 'territory':
                        type = t('defaultClassifiers.territory');
                        break;
                    case 'tribal-area':
                        type = t('defaultClassifiers.tribalArea');
                        break;
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(DataTable_1.TextCell, null, name),
                    row.columns.fips && react_1.default.createElement(DataTable_1.TextCell, null, row.columns.fips),
                    react_1.default.createElement(DataTable_1.TextCell, null, type)));
            },
            tableCellSx: {
                display: {
                    xs: 'table-cell',
                    sm: 'none',
                },
            },
        },
        {
            headerLabel: t('common.name'),
            sortKey: 'name',
            cellFunction: (row) => {
                let name;
                if (row.columns.parentName) {
                    name = row.columns.name + ' (' + row.columns.parentName + ')';
                }
                else {
                    name = row.columns.name;
                }
                return react_1.default.createElement(DataTable_1.TextCell, null, name);
            },
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
                width: '60%',
            },
        },
        {
            headerLabel: t('defaultClassifiers.fips'),
            sortKey: 'fips',
            cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, row.columns.fips),
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
                width: '20%',
            },
        },
        {
            headerLabel: t('common.type'),
            sortKey: 'type',
            cellFunction: (row) => {
                let type = '';
                switch (row.columns.type) {
                    case 'state':
                        type = t('defaultClassifiers.state');
                        break;
                    case 'county':
                        type = t('defaultClassifiers.county');
                        break;
                    case 'territory':
                        type = t('defaultClassifiers.territory');
                        break;
                    case 'tribal-area':
                        type = t('defaultClassifiers.tribalArea');
                        break;
                }
                return react_1.default.createElement(DataTable_1.TextCell, null, type);
            },
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
                width: '20%',
            },
        },
    ], []);
    const filterConfig = (0, FiltersBar_1.useFilterConfig)((builder) => {
        builder.quickSearchFilter({ dataPath: 'search', label: t('common.search') });
        builder.quickSearchFilter({
            dataPath: 'fips',
            label: t('defaultClassifiers.fips'),
            sx: { flex: { xs: '1 1 0', lg: '1 1 0', xl: '1 1 0' } },
        });
        builder.quickFilterMultiSelect({
            dataPath: 'type',
            label: t('common.type'),
            values: [
                { value: 'state', label: t('defaultClassifiers.state') },
                { value: 'county', label: t('defaultClassifiers.county') },
                { value: 'territory', label: t('defaultClassifiers.territory') },
                { value: 'tribal-area', label: t('defaultClassifiers.tribalArea') },
            ],
            widget: 'form.checkboxList',
        });
    }, []);
    return (react_1.default.createElement(material_1.Box, { sx: { height: '100%', overflow: 'auto' } },
        react_1.default.createElement(PageHeader_1.PageHeaderWithImage, { gradient: 'blue-base', title: t('defaultClassifiers.jurisdiction') }),
        react_1.default.createElement(material_1.Box, { p: 4 },
            react_1.default.createElement(DataTable_1.DataTable, { ...dataTableProps, title: t('defaultClassifiers.jurisdiction'), columns: columns, filtersBar: react_1.default.createElement(FiltersBar_1.FiltersBar, { ...filtersBarProps, config: filterConfig, onFilterDebounceDelay: 0 }), tableSx: { tableLayout: 'fixed' } }))));
};
exports.JurisdictionAdminPage = JurisdictionAdminPage;
function useJurisdictionList(request) {
    const response = (0, hooks_1.useStorageList)(shared_1.jurisdictionEntityName, mapJurisdictionRequest(request));
    return {
        ...response,
        data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined,
        reload: response.mutate,
    };
}
function mapJurisdictionRequest({ filterData, sortColumnKey, sortColumnDesc, offset, limit, }) {
    const filter = [];
    if (filterData.search) {
        filter.push({ column: 'search', op: 'full-text-query', value: filterData.search });
    }
    if (filterData.fips) {
        filter.push({ column: 'fips', op: '=', value: filterData.fips });
    }
    if (filterData.type) {
        filter.push({ column: 'type', op: 'in', value: filterData.type });
    }
    return {
        filter: filter,
        orderBy: [{ column: sortColumnKey, desc: sortColumnDesc }],
        offset,
        limit,
    };
}
